import { SectionTab } from "./../../../../../base/section-tab.model";
class MortgageFireHongKongTabSchema {
  tabs!: SectionTab[];
  master!: SectionTab;
  locations!: SectionTab;
  businessInterruption!: SectionTab;
  money!: SectionTab;
  premiumSummary!: SectionTab;
  clausesAndDeductibles!: SectionTab;

  constructor() {
    this.initialize();
  }

  initialize() {
    this.master = new SectionTab("Master", 0);
    this.locations = new SectionTab("Locations", 3);
    this.businessInterruption = new SectionTab("Business Interruption", 4);
    this.money = new SectionTab("Money", 5);
    this.premiumSummary = new SectionTab("Premium Summary", 1);
    this.clausesAndDeductibles = new SectionTab("Clauses and Deductibles", 2);

    this.tabs = [];
    this.tabs.push(this.master);
    this.tabs.push(this.locations);
    this.tabs.push(this.businessInterruption);
    this.tabs.push(this.money);
    this.tabs.push(this.premiumSummary);
    this.tabs.push(this.clausesAndDeductibles);
  }
}

export const MortgageFireHKTabSchema = new MortgageFireHongKongTabSchema();
